var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataGovernanceSecurityBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 727.16 683.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        fill: #002c5f;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.58,
    y: 17.63,
    width: 584,
    height: 648
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 340.91,
    y: 276.6,
    width: 346.67,
    height: 389.03
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m427.08,644.03H136.78c-5.94,0-10.8-4.86-10.8-10.8v-10.8h244.4c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8H71.98c-5.94,0-10.8-4.86-10.8-10.8V168.83h118.8c5.94,0,10.8-4.86,10.8-10.8V39.23h334.8c5.94,0,10.8,4.86,10.8,10.8v203.58c0,5.94,4.86,10.8,10.8,10.8s10.8-4.86,10.8-10.8V82.43h32.4c5.94,0,10.8,4.86,10.8,10.8v184.9c0,5.94,4.86,10.8,10.8,10.8s10.8-4.86,10.8-10.8V93.23c0-17.82-14.58-32.4-32.4-32.4h-32.4v-10.8c0-17.82-14.58-32.4-32.4-32.4H179.98s-.43.11-.65.11c-.97,0-1.94.22-2.91.54-.33.11-.65.21-.97.32-1.19.54-2.27,1.19-3.13,2.16L42.71,150.36c-.97.97-1.62,2.05-2.16,3.13-.11.32-.22.65-.33.97-.32.86-.54,1.83-.54,2.81,0,.21-.11.43-.11.65v432c0,17.82,14.58,32.4,32.4,32.4h32.4v10.8c0,17.82,14.58,32.4,32.4,32.4h290.31c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8v.11ZM169.18,54.46v92.78h-92.77l92.77-92.78Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m680.56,338.71l-162-61.23c-2.48-.97-5.18-.97-7.67,0l-162,61.23c-4.21,1.63-7.02,5.62-7.02,10.16v114.05c0,65.66,36.94,127.33,96.34,161.03l71.06,40.29c1.62.97,3.45,1.4,5.29,1.4s3.67-.43,5.29-1.4l71.06-40.29c59.4-33.69,96.34-95.36,96.34-161.03v-114.05c0-4.54-2.81-8.53-7.02-10.16h.32Zm-14.58,124.2c0,57.89-32.72,112.32-85.43,142.23l-65.78,37.26-65.77-37.26c-52.7-29.81-85.43-84.35-85.43-142.23v-106.6l151.2-57.13,151.2,57.13v106.6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m468.45,452.76c-4.21-4.21-11.02-4.21-15.23,0-4.21,4.21-4.21,11.02,0,15.22l32.4,32.4c2.16,2.16,4.86,3.14,7.67,3.14s5.51-1.08,7.67-3.14l64.8-64.8c4.21-4.21,4.21-11.02,0-15.23-4.21-4.21-11.02-4.21-15.23,0l-57.13,57.13-24.73-24.73h-.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m406.78,460.43c0,59.51,48.49,108,108,108s108-48.49,108-108-48.49-108-108-108-108,48.49-108,108Zm194.4,0c0,47.63-38.77,86.4-86.4,86.4s-86.4-38.77-86.4-86.4,38.77-86.4,86.4-86.4,86.4,38.77,86.4,86.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m298.78,471.23H125.98c-5.94,0-10.8,4.86-10.8,10.8s4.86,10.8,10.8,10.8h172.8c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m298.78,406.43H125.98c-5.94,0-10.8,4.86-10.8,10.8s4.86,10.8,10.8,10.8h172.8c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m298.78,341.63H125.98c-5.94,0-10.8,4.86-10.8,10.8s4.86,10.8,10.8,10.8h172.8c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m298.78,276.83H125.98c-5.94,0-10.8,4.86-10.8,10.8s4.86,10.8,10.8,10.8h172.8c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m482.38,222.83c0-5.94-4.86-10.8-10.8-10.8H125.98c-5.94,0-10.8,4.86-10.8,10.8s4.86,10.8,10.8,10.8h345.6c5.94,0,10.8-4.86,10.8-10.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m471.58,147.23h-194.4c-5.94,0-10.8,4.86-10.8,10.8s4.86,10.8,10.8,10.8h194.4c5.94,0,10.8-4.86,10.8-10.8s-4.86-10.8-10.8-10.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataGovernanceSecurityBi);
export default __webpack_public_path__ + "static/media/Data Governance & Security_BI.174acb857018e1dc19cceffc3b570800.svg";
export { ForwardRef as ReactComponent };